import React from 'react';
import { PapiGallection } from '@wix/da-papi-types';
import { Url } from '@wix/da-url';

export interface Props {
  folder: PapiGallection;
  className?: string;
  onClick?: (e) => void;
}

export const FolderLink: React.FC<React.PropsWithChildren<Props>> = ({
  folder,
  children,
  className,
  onClick,
}) => (
  <a
    onClick={onClick}
    className={className}
    href={Url.userGalleryLink({
      username: folder.owner.username,
      gallectionType: folder.type as any,
      folderId: folder.folderId,
      folderName: folder.name,
    })}
  >
    {children}
  </a>
);
FolderLink.displayName = 'FolderLink';

export default FolderLink;
